import {CSSProperties, FC} from 'react';


export interface IIconNewBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconNewBmw: FC<IIconNewBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m20.173 12 .79-2.06a.563.563 0 0 0-.172-.638L19.08 7.913l-.346-2.179a.562.562 0 0 0-.468-.466l-2.18-.347L14.7 3.208a.563.563 0 0 0-.638-.171L12 3.827l-2.06-.79a.561.561 0 0 0-.638.172L7.914 4.922l-2.179.347a.564.564 0 0 0-.466.467l-.347 2.178-1.713 1.389a.563.563 0 0 0-.171.637l.79 2.06-.79 2.06a.561.561 0 0 0 .17.638l1.714 1.387.347 2.179c.038.24.226.43.466.468l2.18.346 1.387 1.712a.56.56 0 0 0 .64.171L12 20.173l2.06.79a.565.565 0 0 0 .639-.173l1.387-1.712 2.179-.346a.563.563 0 0 0 .468-.468l.346-2.18 1.712-1.386a.562.562 0 0 0 .171-.638l-.79-2.06ZM9.75 13.688a.562.562 0 0 1-1.065.252L7.5 11.57v2.118a.563.563 0 0 1-1.125 0v-4.5a.563.563 0 0 1 1.066-.252l1.184 2.369V9.188a.563.563 0 0 1 1.125 0v4.5Zm2.813-2.813a.563.563 0 0 1 0 1.125H12v1.125h.563a.563.563 0 0 1 0 1.125h-1.125a.563.563 0 0 1-.563-.562v-4.5c0-.31.252-.563.563-.563h1.124a.563.563 0 0 1 0 1.125H12v1.125h.563Zm5.062 2.813a.56.56 0 0 1-.563.562.56.56 0 0 1-.503-.31l-.622-1.245-.622 1.243a.555.555 0 0 1-.633.296.561.561 0 0 1-.432-.546v-4.5a.563.563 0 0 1 1.125 0v2.117l.06-.118c.19-.381.815-.381 1.006 0l.059.118V9.188a.563.563 0 0 1 1.125 0v4.5Z" />
        </svg>
    );
};
